import React from "react";
import { Chip } from "@mui/material";
import styled from "@emotion/styled";

const StyledDepartmentChip = styled(Chip)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: theme.palette.inverted.main,
    color: theme.palette.inverted.contrastText,
}));

const DepartmentChip = ({ department }) => {

    return (
        <StyledDepartmentChip size="small" label={`Department: ${department || "Not Set"}`} />
    );
};

export default DepartmentChip;